import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
  }
  
  body {
    background: ${({ theme }) => theme.colors.body};
    color: ${({ theme }) => theme.colors.font};
    font-family: 'Poppins', sans-serif;
    height: 100vh;
    align-items: center;
  }
`;

export default GlobalStyles;
